export function loyaltyItem(state) {
  return state.loyaltyItem;
}
